export const SERVICE_TYPES = [
    { key: 'ULTRASERVICE', text: 'Ультра' },
    { key: 'PREMIUMSERVICE', text: 'Премиум' },
];
export const SERVICE_DIRECTIONS = [
    { key: 'Физическое лицо' },
    { key: 'Юридическое лицо / ИП' },
];
export const FEEDBACK_TYPES = [
    {
        text: 'Задать вопрос по продуктам и услугам',
        key: 'FEEDBACK',
    },
    {
        text: 'Качество обслуживания',
        key: 'FEEDBACK_QS',
    },
];
export const FEEDBACK_METHOD = [
    { key: 'phone', text: 'Телефонный звонок' },
    { key: 'email', text: 'Электронное сообщение' },
];
export const PRODUCT_TYPE = [
    { key: 'Карта дебетовая', text: 'Карта дебетовая' },
    { key: 'Карта кредитная', text: 'Карта кредитная' },
    { key: 'Потребительский кредит', text: 'Потребительский кредит' },
    { key: 'Ипотечный кредит', text: 'Ипотечный кредит' },
    { key: 'Вклад', text: 'Вклад' },
    { key: 'Накопительный счет', text: 'Накопительный счет' },
];
export const OUT_SERVICE_URL = '/api/v1/outservice/outserviceregions';
//# sourceMappingURL=constants.js.map